import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from "react-router-dom";
import './index.css'
import { AppErrorBoundary } from '@/components/AppErrorBoundary'
import { AuthProvider } from '@/contexts/AuthContext'
import './envCheck.ts'
import App from './App';
import { initializeRPCHealthMonitoring } from './lib/rpcHealthCheck';
import { initializeGlobalErrorHandlers } from './observability/globalHandlers';

// Initialize global error handlers for observability
initializeGlobalErrorHandlers();

// Initialize RPC health monitoring
initializeRPCHealthMonitoring().catch(error => {
  console.error('[main] Failed to initialize RPC health monitoring:', error);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <AuthProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </AppErrorBoundary>
  </React.StrictMode>,
)